.container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--color-surface);
  color: var(--color-text);
  font-size: 13px;
}

.toolbar {
  padding: 8px;
  border-bottom: 1px solid var(--color-border);
  display: flex;
  gap: 8px;
  align-items: center;
}

.filters {
  display: flex;
  gap: 8px;
}

.content {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
}

.table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.table th {
  padding: 8px;
  border-bottom: 1px solid var(--color-border);
  font-weight: 500;
  color: var(--color-text-dim);
  position: sticky;
  top: 0;
  background: var(--color-surface);
  z-index: 1;
}

.row {
  border-bottom: 1px solid var(--color-border-subtle);
}

.row td {
  padding: 8px;
}

.row:hover {
  background: var(--color-surface-hover);
}

.normalRow {
  opacity: 0.7;
}

.empty {
  text-align: center;
  padding: 24px !important;
  color: var(--color-text-dim);
  font-style: italic;
}

.badgeActive {
  background: var(--color-error);
  color: #fff;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
}

.badgeNormal {
  background: var(--color-success);
  color: #000;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
}

.link {
  color: var(--color-primary);
  cursor: pointer;
  text-decoration: underline;
}

.link:hover {
  color: var(--color-primary-hover);
}

.acked {
  color: var(--color-text-dim);
  font-size: 11px;
}
